export const SITE_URL = "https://www.creditcardfeecalculator.com";
export const SITE_NAME = "Credit Card Fee Calculator";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/cash-advance-calculator", label: "Cash Advance" },
  { to: "/balance-transfer-fee-calculator", label: "Balance Transfer" },
  { to: "/foreign-transaction-fee-calculator", label: "Foreign TX" },
  { to: "/finance-charge-calculator", label: "Finance Charge" },
  { to: "/annual-fee-calculator", label: "Annual Fee" },
];

export const ALL_CALCULATORS = [
  { to: "/", title: "Credit Card Fee Calculator", desc: "Multi-tool estimator for every major credit card fee.", tag: "Main" },
  { to: "/finance-charge-calculator", title: "Finance Charge / Interest", desc: "Estimate monthly interest from APR, balance and billing days.", tag: "Interest" },
  { to: "/cash-advance-calculator", title: "Cash Advance Calculator", desc: "Advance fee + daily interest from ATM or cash-like transactions.", tag: "Cash Advance" },
  { to: "/balance-transfer-fee-calculator", title: "Balance Transfer Calculator", desc: "Transfer fee, intro APR savings and payoff timeline.", tag: "Transfer" },
  { to: "/foreign-transaction-fee-calculator", title: "Foreign Transaction Fee", desc: "Convert currency and add issuer foreign-transaction fees.", tag: "Travel" },
  { to: "/visa-exchange-rate-calculator", title: "Visa Exchange Rate", desc: "Visa-style FX conversion with optional issuer fee.", tag: "Visa" },
  { to: "/amex-foreign-transaction-calculator", title: "Amex Foreign Transaction", desc: "Amex FX conversion and foreign-transaction fee estimate.", tag: "Amex" },
  { to: "/late-fee-calculator", title: "Late Fee Calculator", desc: "Flat late fee plus interest for days late.", tag: "Late Fee" },
  { to: "/annual-fee-calculator", title: "Annual Fee Break-even", desc: "Is the annual fee worth it vs. rewards and credits?", tag: "Rewards" },
  { to: "/percentage-fee-calculator", title: "Percentage / Surcharge", desc: "Any % fee or merchant surcharge on a transaction.", tag: "Surcharge" },
];

export const DISCLAIMER =
  "Results are estimates for educational purposes only. Actual fees and interest depend on your card issuer's terms. Always check your cardmember agreement.";
